/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import api from '../../../services/api';

const API_URL = '/api/v1/employee/bidProfile';

/**
 * @param {string} profileId
 * @param {{
 *  employeeIds: number[]
*  searchQuery: string
*  pageIndex: number
*  pageSize: number
*  sortColumn: number
*  isSortAscending: boolean
*  dataviewKeyAlias: string[]
* }} searchParams
 * @returns {Promise<ApiEmployee.GetEmployeeBidResultResponse>}
 */
export const getEmployeeBidResult = (profileId, searchParams) =>
    api.post(`${API_URL}/${profileId}/report/employeeBidResult`, searchParams);

/**
 * @param {string} profileId
 * @param {EmployeePreferencesReport.IEmployeeReportFilters} filters
 * @param {EmployeePreferencesReport.IPagination} pagination
 * @param {EmployeePreferencesReport.ISortParameters} sort
 * @returns {Promise<ApiEmployee.EmployeesSelectionResponse>}
 */
export const EmployeesSelection = (profileId, filters, pagination, sort) => api.post(`${API_URL}/${profileId}/report/employeesSelection`, {
    searchQuery: filters.search,
    employeeIdsFilter: filters.selectedEmployees,
    dataviewColumnsFilter: filters.dataviewColumnsFilter,
    pageIndex: pagination.pageNumber - 1,
    pageSize: pagination.pageSize,
    sortColumn: sort.sortColumn,
    sortOrder: sort.sortOrder,
});
